<template>
  <div data-app>
    <template>
      <transition name="fade">
        <v-row>
          <v-col
            :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'"
            v-if="$store.getters.showConv"
          >
            <ConversationList
              @getSelectedConversation="getSelectedConversation"
              @getShowConv="getShowConv"
            >
            </ConversationList>
          </v-col>
          <v-divider vertical :height="`${winHeight - 200}px`"></v-divider>
          <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : '6'">
            <ThreadsList
              :key="threadKey"
              v-if="selectedConversation && $store.getters.showThread"
              @getConversationId="getConversationId"
              @closeThreadList="showThread = false"
              :topic="selectedConversation.category.topic"
              :type="selectedConversation.category.type"
              :objectId="selectedConversation.objectId"
              :conversationId="selectedConversation.id"
              :recipientUserId="selectedConversation.recipientUserId"
              :recipientMerchantId="selectedConversation.recipientMerchantId"
              :createdByMerchantId="
                selectedConversation.createdByMerchantId
                  ? selectedConversation.createdByMerchantId
                  : selectedConversation.recipientMerchantId
              "
              :isUserBase="false"
            >
            </ThreadsList>
          </v-col>
        </v-row>
      </transition>
    </template>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { mapGetters } from 'vuex';
import { RepoFactory } from '../../../baseRepository/Factory';
const merchantMessagesRepository = () => RepoFactory.get('merchantMessages');
import Helper from '../../../core/helpers';
import ConversationList from '@/components/core/conversation/components/ConversationList.vue';
import ThreadsList from '@/components/core/conversation/components/ThreadsList.vue';

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: { ConversationList, ThreadsList },
  data() {
    return {
      winHeight: 0,
      threadKey: 0,
      showConv: true,
      selectedConversation: null,
    };
  },

  computed: {
    ...mapGetters(['userBusinessInformation', 'merchantMessages']),
    ...mapGetters(['unreadeMessageCount']),
    messages: {
      get() {
        return this.merchantMessages;
      },
      set(newValue) {
        // this.$store.commit('setUserBusinessInformation', newValue);
      },
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    baseUrl() {
      return this.$store.getters.inventoryBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  mounted() {
    this.winHeight = window.innerHeight;
  },
  methods: {
    getConversationId(val) {
      this.selectedConversation.id = val;
      this.threadKey += 1;
    },
    getShowConv(val) {
      this.showConv = val;
    },
    readMessage(messageItem) {
      const params = {
        messageId: messageItem.id,
      };
      merchantMessagesRepository()
        .readMessage(
          this.userBusinessInformation.merchantId,
          this.merchantBaseUrl,
          params
        )
        .then(() => {
          messageItem.read = true;
        });
    },
    getSelectedConversation(val) {
      this.selectedConversation = val;
      this.threadKey += 1;
    },
  },
};
</script>
<style></style>
